<template>
  <ul
    v-if="stackRecommendations.length"
    class="rounded-md border-t-0 border-[#D7D7D9]"
  >
    <li
      v-for="([attribute, recommendations], index) in stackRecommendations"
      :key="`${attribute}-collapsible`"
    >
      <Collapsible
        :title="getRecommendationTitle(attribute, $i18n)"
        additional-classes="text-lg font-medium py-2 px-3 border-[#D7D7D9] rounded-md border-t-[1px]"
        :opened="index === 0"
      >
        <hr class="border-t-[#D7D7D9]" />
        <FimRecommendations
          :recommendation-product="recommendationProduct"
          :product-recommendations="recommendations"
          :location="location"
          :current-product-category="currentProductCategory"
          layout="singleItemSlider"
          class="px-3 pt-2"
        />
      </Collapsible>
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-core'
import FimRecommendations from './FimRecommendations.vue' // explicit
import type { ProductRecommendation } from '~/composables/useProductRecommendations'
import {
  PRODUCT_RECOMMENDATION_ATTRIBUTE_REF_RELATED,
  PRODUCT_RECOMMENDATION_ATTRIBUTE_REF_SUBSTITUION,
  PRODUCT_RECOMMENDATION_ATTRIBUTE_REF_UPSELL,
  type ProductRecommendationAttribute,
} from '~/constants/product'

const PRODUCT_RECOMMENDATION_STACK_ATTRIBUTES = [
  PRODUCT_RECOMMENDATION_ATTRIBUTE_REF_UPSELL,
  PRODUCT_RECOMMENDATION_ATTRIBUTE_REF_SUBSTITUION,
  PRODUCT_RECOMMENDATION_ATTRIBUTE_REF_RELATED,
] as const

type StackItem = [
  (typeof PRODUCT_RECOMMENDATION_STACK_ATTRIBUTES)[number],
  ProductRecommendation[],
]

const props = defineProps({
  recommendationProduct: {
    type: Object as PropType<Product>,
    required: true,
  },
  productRecommendations: {
    type: Object as PropType<{
      [key in ProductRecommendationAttribute]?: ProductRecommendation[]
    }>,
    required: true,
  },
  location: FimRecommendations.props.location,
  currentProductCategory: FimRecommendations.props.currentProductCategory,
})

const stackRecommendations = PRODUCT_RECOMMENDATION_STACK_ATTRIBUTES.map(
  (attribute) =>
    Boolean(props.productRecommendations?.[attribute]?.length) && [
      attribute,
      props.productRecommendations?.[attribute],
    ],
).filter((v): v is StackItem => Boolean(v))

const {$i18n} = useNuxtApp()

</script>
